/* tslint:disable */
export var closeX = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\">\n  <path d=\"M5.209 3.793L9 0l1.415 1.414-3.793 3.793L10.416 9 9 10.414 5.21 6.621l-3.795 3.795L0 9l3.794-3.794L.001 1.414 1.416 0l3.793 3.793z\"/>\n</svg>";
//# sourceMappingURL=close-x.icon.js.map